<div class="chip-group" [ngClass]="design">
    <div class="chip" *ngFor="let chip of chips; index as i">
        {{ chip.label }}
        <app-button-icon *ngIf="chip.isRemoved !== false" icon="icon-close" (buttonClicked)="removeChip(i, chip)" [disabled]="disabled"></app-button-icon>
    </div>
</div>